import React , {useContext} from 'react'
import {Container} from 'react-bootstrap';
import {NavLink} from 'react-router-dom';

import { MouseContext } from "../context/mouseContext"
//images
import Logo from '../Assets/badges/logo.svg';
import Facebook from '../Assets/badges/facebook.svg';
import Instagram from '../Assets/badges/instagram.svg';
import phone from '../Assets/badges/phone.svg';

const Header = () => {
    const {  cursorChangeHandler } = useContext(MouseContext);
    return (
        <header className="fixed-top">
             <Container>
                 <div className="d-flex justify-content-between align-items-center py-3">
                    <div className="logo-warpper">
                       <NavLink 
                            to="/"
                            onMouseEnter={() => cursorChangeHandler("hovered")}
                            onMouseLeave={() => cursorChangeHandler("")}
                            > 
                                <img src={Logo} alt="logo" className="img-fluid" width={60} height={51}/> 
                       </NavLink>
                    </div>
                    <div className="social-links d-flex">
                        <a 
                            href="https://www.facebook.com/maclinegroup/" 
                            target="_blank"
                            onMouseEnter={() => cursorChangeHandler("hovered")}
                            onMouseLeave={() => cursorChangeHandler("")}
                            rel="noreferrer noopener" 
                            className="facebook mx-1"
                        >
                            <img src={Facebook} alt="facebook link"  width={25} height={25}/>
                        </a>
                        <a 
                            href="https://www.instagram.com/maclinegroup/" 
                            target="_blank"
                            onMouseEnter={() => cursorChangeHandler("hovered")}
                            onMouseLeave={() => cursorChangeHandler("")}
                            rel="noreferrer noopener" 
                            className="insta mx-1"
                        >
                            <img src={Instagram} alt="instagram link" width={25} height={25}/>
                        </a>

                        <a 
                            href="tel:+97126714044"
                            onMouseEnter={() => cursorChangeHandler("hovered")}
                            onMouseLeave={() => cursorChangeHandler("")}
                            rel="noreferrer noopener" 
                            className="insta mx-1 d-md-none d-block"
                        >
                            <img src={phone} alt="phone-number" width={25} height={25}/>
                        </a>
                    </div>
                </div>
            </Container>
        </header>
    )
}

export default Header;
